/**
 * @generated SignedSource<<aba6c9bc59e02b41122553682539a4e3>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type experienceRegistry_issueNavigator_SidebarExperienceRegistryWithErrorBoundary_project$data = {
  readonly " $fragmentSpreads": FragmentRefs<"experienceRegistry_issueNavigator_SidebarExperienceRegistry_project">;
  readonly " $fragmentType": "experienceRegistry_issueNavigator_SidebarExperienceRegistryWithErrorBoundary_project";
};
export type experienceRegistry_issueNavigator_SidebarExperienceRegistryWithErrorBoundary_project$key = {
  readonly " $data"?: experienceRegistry_issueNavigator_SidebarExperienceRegistryWithErrorBoundary_project$data;
  readonly " $fragmentSpreads": FragmentRefs<"experienceRegistry_issueNavigator_SidebarExperienceRegistryWithErrorBoundary_project">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "experienceRegistry_issueNavigator_SidebarExperienceRegistryWithErrorBoundary_project",
  "selections": [
    {
      "kind": "FragmentSpread",
      "name": "experienceRegistry_issueNavigator_SidebarExperienceRegistry_project"
    }
  ],
  "type": "JiraProject"
};

(node as any).hash = "af3a08a5830cf80396852c8c7e211c1e";

export default node;
